import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=05f14c74&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=05f14c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f14c74",
  null
  
)

export default component.exports